import React, { useState } from "react";
import AmiChat from "./AmiChat";
import AmiLogo from '../assets/icons/amiwareLogo.png';

const FloatingButton = () => {
  const [showChat, setShowChat] = useState(false);

  return (
    <>
      {/* Floating Chat Window */}
      <div
        className="position-fixed d-flex flex-column bg-white shadow-lg"
        style={{
          width: "40vw",
          minWidth: "350px",
          maxWidth: "900px",
          height: "80vh",
          bottom: showChat ? "100px" : "-100%",
          right: "20px",
          zIndex: 1051,
          transition: "bottom 0.4s ease-in-out",
          borderRadius: "15px",
          overflow: "hidden",
          display: showChat ? "flex" : "none",  // Ensures it's hidden when closed
        }}
      >        
        {/* Chat Content - Enable proper scrolling */}
        <div 
          className="flex-grow-1"
          style={{
            height: "100%",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <AmiChat />
        </div>
      </div>

      {/* Floating Button */}
      <button
        className="btn btn-primary position-fixed rounded-circle d-flex align-items-center justify-content-center"
        style={{
          bottom: "30px",
          right: "30px",
          width: "60px",
          height: "60px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
          zIndex: 1052,
          fontSize: "20px",
          fontWeight: "bold",
          // border: "3px solid gold",
          transition: "0.4s ease-in-out",
        }}
        onClick={() => setShowChat(!showChat)}
      >
        <img
          src={AmiLogo}
          alt="Ami Logo"
          className="img-fluid"
          style={{
            width: "35px",
            borderRadius: "50%",
            padding: "2px",
          }}
        />
      </button>
    </>
  );
};

export default FloatingButton;